import { render } from "./GroupTicketNotificationDialog.vue?vue&type=template&id=18e6e94a"
import script from "./js/groupTicketNotificationDialog.js?vue&type=script&lang=js&external"
export * from "./js/groupTicketNotificationDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__